import React, { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Form, TreeSelect, Spin } from 'antd'
import { groupBy, map, filter, includes, split, last } from 'lodash-es'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'
import { SCRAPING_TAGS } from '../../../graphql/queries'
import { SCRAPING_TAG_TYPES } from '../../../constants'

const ScrapingTagsFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { data: { scrapingTags = {} } = {}, loading: isLoadingTags } = useQuery(
    SCRAPING_TAGS,
    {
      fetchPolicy: 'no-cache',
    },
  )

  const scrapingTagsByType = groupBy(scrapingTags, 'type')

  const treeData = map(SCRAPING_TAG_TYPES, scrapingTagType => ({
    title: scrapingTagType.name,
    value: scrapingTagType.value,
    key: scrapingTagType.value,
    children: map(scrapingTagsByType[scrapingTagType.value], scrapingTag => ({
      title: scrapingTag.name,
      value: `${scrapingTagType.value}.${scrapingTag.id}`,
    })),
  }))

  const { tagIds } = getQueryParams(search)

  const treeSelectValue = useMemo(() => {
    const selectedTags = filter(scrapingTags, ({ id }) =>
      includes(tagIds, Number(id)),
    )

    return map(selectedTags, ({ type, id }) => `${type}.${id}`)
  }, [scrapingTags, tagIds])

  const handleChange = useCallback(
    values => {
      const tagIds = map(values, value => last(split(value, '.')))
      history.push(
        createUrl(pathname, search, {
          tagIds,
        }),
      )
    },
    [history, pathname, search],
  )

  return (
    <Form.Item
      label="Tags"
      colon={false}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      {isLoadingTags ? (
        <Spin />
      ) : (
        <TreeSelect
          multiple
          style={{ width: '600px' }}
          treeData={treeData}
          value={treeSelectValue}
          onChange={handleChange}
          treeCheckable
        />
      )}
    </Form.Item>
  )
}

export default ScrapingTagsFilter
